import React from 'react'
import { Box, Button, Checkbox, Dialog, Divider, FormControl, FormControlLabel, FormLabel, ListItem, ListItemText, Menu, MenuItem, RadioGroup, Slide } from '@material-ui/core'
import { FaFileCsv, FaUsers } from 'react-icons/fa'
import { MdClose, MdPublic } from 'react-icons/md'
import { RiBarChart2Fill } from 'react-icons/ri'
import { reports, reset } from '../../../store/actions/campaigns.action'
import { useDispatch } from 'react-redux'

export default function MenuChart({ mobile = false, item, menuEl, onClose }) {
    const dispatch = useDispatch()
    const { start_date, end_date } = item

    const [state, setState] = React.useState({
        menuEl: null
    })

    const fields = [
        "nome",
        "cpf",
        "data_nascimento",
        "telefone",
        "email",
        "valor",
        "quantidade",
        "total",
        "data_hora_compra",
        "forma_pagamento",
        "codigo_transacao",
        "instituicao_bancaria",
        "situacao_pagamento",
        "created_at",
        "updated_at",
        "bilhetes"
    ];

    const fieldLabels = {
        nome: "Nome",
        cpf: "CPF",
        data_nascimento: "Data de Nascimento",
        telefone: "Telefone",
        email: "Email",
        valor: "Valor",
        quantidade: "Quantidade",
        total: "Total",
        data_hora_compra: "Data compra",
        forma_pagamento: "Forma de pag.",
        codigo_transacao: "Cód. transação",
        instituicao_bancaria: "Banco",
        situacao_pagamento: "Situação pag.",
        created_at: "Criado em",
        updated_at: "Atualizado em",
        bilhetes: "Bilhetes",
    }
      
    const reportInit = Object.fromEntries(fields.map(f => [f, true]));

    const [report, setReport] = React.useState({ 
        ...reportInit,
        open: false,
        campaign_id: null,
    })

    const [form, setForm] = React.useState({ 
        ...reset,
        type: 'telefone'
    })

    const filterReport = (data) => Object.fromEntries(
        Object.entries(data).filter(([key, value]) => value === true && key !== 'open')
    )

    React.useEffect(() => {
        setState({ menuEl: menuEl })
    }, [menuEl])

    React.useEffect(() => {
        if(state.menuEl === null) {
            onClose()
        }
    }, [state.menuEl])

    const handleChange = (event) => {
        setReport({ ...report, [event.target.name]: event.target.checked })
    }

    const Transition = React.forwardRef((props, ref) => {
        return <Slide direction="up" ref={ref} {...props} />
    })

    return (
        <>
        
        <Dialog
            open={report.open}
            maxWidth="md"
            style={{width: '100%'}}
            onClose={() => setReport({...report, open: false, campaign_id: null})}
            className="center bg-modal"
        >
            <div className="card-body pb-4 bs-bg">
                <div>
                    <div className="alert alert-warning border-0 small" role="alert">
                        <strong>Aviso de privacidade</strong> <br></br>
                        De acordo com a Lei Geral de Proteção de Dados Pessoais (LGPD), os dados exibidos neste relatório são confidenciais.
                        <br></br><strong>Não compartilhe</strong> esses dados com terceiros.
                    </div>

                    <FormControl component="fieldset">
                        <FormLabel className="bs-color" component="legend">Gerar relatório com:</FormLabel>
                        <RadioGroup
                            name="order"
                            value={form.type}
                            onChange={ e => setForm({...reset, type: e.target.value})}
                            className="fw-normal bs-color-b"
                        >
                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: { xs: "1fr 1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
                                    columnGap: 2,
                                    rowGap: 1,
                                }}
                            >
                                {fields.map((item, index) => (
                                    <FormControlLabel
                                        key={index}
                                        value={item}
                                        control={<Checkbox color="primary" checked={report[item]} onChange={handleChange} name={item} />} 
                                        label={fieldLabels[item]}
                                    />
                                ))}
                            </Box>
                        </RadioGroup>
                    </FormControl>
                </div>

                <div className="d-block mt-4">
                    <div className="d-flex justify-content-end">
                        <button onClick={() => setReport({...report, open: false, campaign_id: null})} className="btn btn-light ms-auto">
                            <MdClose size="1.5em" className="me-2" />
                            Fechar
                        </button>
                        
                        <Button 
                            onClick={() => {
                                dispatch(reports(
                                    {
                                        ...filterReport(report),
                                        start_date: start_date,
                                        end_date: end_date
                                    }, 
                                    report.campaign_id
                                ))
                                setReport({...report, open: false})
                            }} 
                            disabled={(!report.name && !report.email && !report.telefone)}
                            className="ms-2" 
                            variant="contained" 
                            color="primary" 
                            size="large"
                            startIcon={<FaFileCsv />}
                        >
                            Baixar
                        </Button>
                    </div>
                </div>
            </div>
        </Dialog>

        {(Boolean(state.menuEl)) &&
            <Menu
                anchorEl={state.menuEl}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                TransitionComponent={mobile ? Transition : undefined}
                open={state.menuEl ? true : false}
                onClose={() => setState({ menuEl: null })}
            >
                <ListItem className="item-title ps-4 menu">
                    <ListItemText primary="Exportar relatório" />
                </ListItem>

                <MenuItem 
                    className="fw-bold bs-color-b ms-3" 
                    onClick={() => {
                        setState({ menuEl: null })
                        setReport({...report, open: true, campaign_id: item?.campaign?.id})
                    }}
                >   
                    <div className="d-flex">
                        <RiBarChart2Fill size="1.2em" className="me-4" /> 
                        <div className="d-flex flex-column">
                            <strong>Relatório completo</strong>
                            <small className="text-muted">Todos dados da compra (inclui dados sensíveis)</small>
                        </div>
                    </div>
                </MenuItem>
                <Divider />

                <MenuItem
                    className="fw-bold bs-color-b ms-3" 
                    onClick={() => {
                        setState({ menuEl: null })
                        dispatch(reports(
                            {
                                start_date: start_date,
                                end_date: end_date
                            }, 
                            item?.campaign?.id,
                            'public'
                        ))
                    }}
                >
                    <div className="d-flex">
                        <MdPublic size="1.2em" className="me-4" /> 
                        <div className="d-flex flex-column">
                            <strong>Lista pública de compras</strong>
                            <small className="text-muted">Sem dados pessoais (ideal para divulgação)</small>
                        </div>
                    </div>
                </MenuItem>
                <Divider />

                <MenuItem 
                    className="fw-bold bs-color-b ms-3"
                    onClick={() => {
                        setState({ menuEl: null })
                        dispatch(reports(
                            {
                                start_date: start_date,
                                end_date: end_date
                            }, 
                            item?.campaign?.id,
                            'users'
                        ))
                    }}
                >
                    <div className="d-flex">
                        <FaUsers size="1.2em" className="me-4" /> 
                        <div className="d-flex flex-column">
                            <strong>Lista de Usuários</strong>
                            <small className="text-muted">Todos os compradores da campanha</small>
                        </div>
                    </div>
                </MenuItem>

                <div className='mt-3'></div>
            </Menu>
            }
        </>
    )
}
